import styled from '@emotion/styled';
import MicrositeHero from '~/components/MicrositeHero';
import { useListingContext } from '~/editor/plugin/ListingPlugin';
import { DEMO_PHOTOS } from '~/demo';

interface HeroBlockDeltaProps {
	address1?: string;
	address2?: string;
}

const Wrapper = styled.section`
	position: relative;
	width: 100%;
`;

const HeroFrame = styled.div`
	position: relative;
	width: 100%;
	aspect-ratio: 16 / 9;
	overflow: hidden;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		height: 100vh;
		aspect-ratio: auto;
	}
`;

const Overlay = styled.div`
	position: absolute;
	inset: 0;
	display: none;
	flex-direction: column;
	justify-content: flex-end;
	padding: 2rem 4rem;
	color: white;
	background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		display: flex;
	}
`;

const TopRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 2rem;
`;

const Price = styled.span`
	font-size: 3.5rem;
	font-weight: 500;
`;

const AddressBlock = styled.div`
	text-align: right;
	text-transform: uppercase;
`;

const Address1 = styled.span`
	font-size: 2.5rem;
	display: block;
`;

const Address2 = styled.span`
	font-size: 1.75rem;
	display: block;
`;

const DividerRow = styled.div`
	display: flex;
	align-items: center;
	gap: 1rem;
	margin: 1rem 0 0.5rem;
`;

const Divider = styled.div`
	flex: 1;
	height: 1px;
	background: rgba(255, 255, 255, 0.7);
`;

const OfferedAt = styled.span`
	letter-spacing: 0.2em;
	text-transform: uppercase;
	font-size: 1rem;
`;

const Tagline = styled.span`
	align-self: flex-end;
	margin-top: 0.5rem;
	padding: 0.5rem 1.25rem;
	background: rgba(0, 0, 0, 0.7);
	text-transform: uppercase;
	font-size: 1.5rem;
`;

export default function HeroBlockDelta({ address1, address2 }: HeroBlockDeltaProps) {
	const listing = useListingContext();

	return (
		<Wrapper>
			<HeroFrame>
				<MicrositeHero image={DEMO_PHOTOS[0]} />
				<Overlay>
					<TopRow>
						<div>
							{listing.price_formatted && <Price>${listing.price_formatted}</Price>}
							<span>2% Buyer's Agent Compensation</span>
						</div>
						<AddressBlock>
							{address1 && <Address1>{address1}</Address1>}
							{address2 && <Address2>{address2}</Address2>}
						</AddressBlock>
					</TopRow>
					<DividerRow>
						<Divider />
						<OfferedAt>Offered At</OfferedAt>
						<Divider />
					</DividerRow>
					<Tagline>Sold in 4 days!</Tagline>
				</Overlay>
			</HeroFrame>
		</Wrapper>
	);
}
